import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";
// eslint-disable-next-line max-classes-per-file
import ExtendableError from 'es6-error';
import stringifyNode from './lib/stringify-node';
export var MigrationError = /*#__PURE__*/function (_ExtendableError) {
  _inherits(MigrationError, _ExtendableError);

  var _super = _createSuper(MigrationError);

  function MigrationError() {
    _classCallCheck(this, MigrationError);

    return _super.apply(this, arguments);
  }

  return MigrationError;
}(ExtendableError);
export var ValidationError = /*#__PURE__*/function (_ExtendableError2) {
  _inherits(ValidationError, _ExtendableError2);

  var _super2 = _createSuper(ValidationError);

  function ValidationError(node) {
    var _this;

    _classCallCheck(this, ValidationError);

    _this = _super2.call(this, node);
    _this.message = "node not valid: ".concat(stringifyNode(node)); // eslint-disable-line no-use-before-define

    return _this;
  }

  return ValidationError;
}(ExtendableError);
export var SemverValidationError = /*#__PURE__*/function (_ValidationError) {
  _inherits(SemverValidationError, _ValidationError);

  var _super3 = _createSuper(SemverValidationError);

  function SemverValidationError(message) {
    var _this2;

    _classCallCheck(this, SemverValidationError);

    _this2 = _super3.call(this, message);
    _this2.message = "Invalid simple semver: ".concat(message); // eslint-disable-line no-use-before-define

    return _this2;
  }

  return SemverValidationError;
}(ValidationError);